/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { recommendationsPageAnalytics } from '../../analyticsConsts';
import { useOnboardingDataContext } from '../../context/OnboardingData';
import { usePreferencesContext } from '../../context/preferences';
import useOnboardingURL from '../../hooks/useOnboardingURL';
import Button from '../Button';
import OnboardingCriteria from '../OnboardingCriteria';
import Text from '../Text';
import useStyles from './styles';

const RecommendationsHero = ({
  textSize = 1,
  text,
  images,
  overlayVariation = 4,
  isOnBoardingCriteriaIncluded = false,
  scrolldirectionContext,
  headerHeight,
  isRec = false,
  ctaText,
  quickSearch,
  ...rest
}) => {
  const styles = useStyles();
  const { main } = text;
  const history = useHistory();
  const getOnboardingURL = useOnboardingURL();
  const { RECOMMENDED_FOOTBALL_TYPE_CTA_START_SEARCH } =
    recommendationsPageAnalytics;
  const { preferences } = usePreferencesContext();
  const { OptforCurrentLocation, ReadableLocation } = preferences;
  const { setOnboardingDataContext } = useOnboardingDataContext();

  return (
    <section
      className="section section--hero"
      css={styles.sectionHero(
        images,
        overlayVariation,
        scrolldirectionContext,
        headerHeight,
        isRec
      )}
    >
      <div className="container">
        <div className="hero-content" css={styles.heroContent}>
          {main && (
            <Text as="h1" size={textSize} css={styles.mainText}>
              Showing football{' '}
              <span
                css={ReadableLocation ? styles.none : styles.RedUnderLineStripe}
              >
                <span>near</span>
              </span>{' '}
              <span css={styles.RedUnderLineStripe}>
                <span>
                  { OptforCurrentLocation === "Yes" ? 'your location' : ReadableLocation }
                </span>
              </span>
            </Text>
          )}
          <div css={styles.bannerDescription}>
            {isOnBoardingCriteriaIncluded && !quickSearch && (
              <OnboardingCriteria />
            )}
          </div>
          <Button
            id={RECOMMENDED_FOOTBALL_TYPE_CTA_START_SEARCH}
            css={styles.cta}
            onClick={() => {
              setOnboardingDataContext({}); // Reset onboarding context
              history.push(
                quickSearch
                  ? `${getOnboardingURL}&quick=true`
                  : getOnboardingURL
              );
            }}
            role="button"
            tabIndex={0}
          >
            {ctaText}
          </Button>
        </div>
      </div>
    </section>
  );
};

RecommendationsHero.propTypes = {
  textSize: PropTypes.number,
  text: PropTypes.object,
  images: PropTypes.object,
  overlayVariation: PropTypes.number,
  isOnBoardingCriteriaIncluded: PropTypes.bool,
  scrolldirectionContext: PropTypes.string,
  headerHeight: PropTypes.string,
  isRec: PropTypes.bool,
  ctaText: PropTypes.string,
};

export default RecommendationsHero;
